interface AuthFormActionsProps {
  isSignUp: boolean;
  onToggleMode: () => void;
  onForgotPassword?: () => void;
}

export const AuthFormActions = ({ isSignUp, onToggleMode, onForgotPassword }: AuthFormActionsProps) => {
  return (
    <div className="flex flex-col space-y-2">
      <button
        type="button"
        onClick={onToggleMode}
        className="w-full text-sm text-primary-foreground hover:underline"
      >
        {isSignUp ? "Already have an account? Sign in" : "Need an account? Sign up"}
      </button>
      {!isSignUp && onForgotPassword && (
        <button
          type="button"
          onClick={onForgotPassword}
          className="w-full text-sm text-primary-foreground hover:underline"
        >
          Forgot your password?
        </button>
      )}
    </div>
  );
};